import "./InputBlock.scss";
import React from 'react';
import PropTypes from 'prop-types';
import {Input} from 'reactstrap';
import NumberFormat from 'react-number-format';
import ErrorDisplay from "./ErrorDisplay";
import Render from "./Render";

function InputBlock({value, setValue, label, errorMessage, isNumberFormat=false, useUnformattedValue=false, ...other}) { 
  const { labelTop } = other;
  const handleChange = (e) => {
    if(!useUnformattedValue) {
      setValue && setValue(e.target.value);
    }
  }

  return (
    <div className="input-wrapper">
      <Render condition={labelTop}>
        <div className="input-label">{labelTop}</div>
      </Render>
      <div className="input-content">
        <div className={"value-display"}>
          {
            isNumberFormat 
            ? <NumberFormat customInput={Input} defaultValue={value} value={value} onChange={handleChange} {...other} />
            : <Input defaultValue={value} onChange={handleChange} {...other} />
          }
        </div>
      </div>
      <Render condition={label}>
        <div className="input-label">{label}</div>
      </Render>
      <ErrorDisplay error={errorMessage}/>
    </div>
  );
};

InputBlock.propTypes = {
  className: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  defaultValue: PropTypes.any,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string)
}

export default InputBlock;